import Vue from 'vue'
import dayjs from '@app/js/lib/dayjs';
import _ from 'underscore'
Vue.filter('filmSeats', info => {
    let seats = info.split("|")
    let seats2 = _.map(seats, aSeat => {
        let a = aSeat.split(':')
        return `${a[0]}排${a[1]}座`
    })
    return seats2.join(" ")
})

Vue.filter('filmTime', function(value) {
    if(value == ""){
      return ""
    }
    let filmDate = dayjs.unix(value)
    return `${filmDate.format('dddd YYYY-MM-DD HH:mm')}`;
})

Vue.filter('codeFormat', function (code) {
  return code.slice(0, 4) + " " + code.slice(4, 8) + ' ' + code.slice(8, code.length)
})
